import { BehaviorSubject } from 'rxjs'

// http://reactivex.io/rxjs/manual/overview.html#behaviorsubject
// replays last value

export default new BehaviorSubject(null) // value type - null or number
